var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pls-ui-v4',{attrs:{"isLazyLoading":_vm.loading === 'lazy',"consumer-id":"FCIS_FE","locale":_vm.plsLocal},domProps:{"product":_vm.product,"templateConfig":_vm.templateConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }